import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';
// import { $ } from 'jquery';
import { createRoute } from 'lib/util';
import Dropzone from 'react-dropzone';

const EmployeeForm = ({
  company,
  errors,
  handleAddYear,
  handleRemoveYear,
  handleSubmit,
  handleValueChange,
  handleGroupChange, //groups
  handleCustomFieldChange, //groups
  groups, //groups
  isSaving,
  isSubmitted,
  subcompany,
  t,
  values,
  customFieldss,
  activeImage = false,
  onDragEnter = () => {},
  onDragLeave = () => {},
  handleFileSelected = () => {},
}) => {
  console.log('%c ' + JSON.stringify(values.img), 'background: #222; color: #bada55');

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <div className="col-md-12 mt-3">
        <div className="row align-items-center">
          <div className="col-md-3 col-sm-12">
            {/* Image */}
            <Dropzone
              className={classnames('files-dropzone ', { active: activeImage })}
              // style={{ padding: "0px", maxHeight: "5px" }}
              accept={'.png,.PNG,.jpg,.JPG,.jpeg,.JPEG'}
              multiple={false}
              onDrop={handleFileSelected}
              onDragEnter={onDragEnter}
              onDragLeave={onDragLeave}
            >
              <div className="col-sm-12 col-md-12  col-xl-12 text-center">
                {values.img && values.img.file ? (
                  // <a href={values.img.preview} target="__brank">
                  <img src={values.img.preview} style={{ maxWidth: '100%', maxHeight: '200px' }} />
                ) : // </a>
                values.imgUrl ? (
                  <img src={values.imgUrl} style={{ width: '100%' }} />
                ) : (
                  <p>
                    <i className="fa fa-cloud-upload fa-lg" style={{ padding: '0px' }} />
                    {'  '}
                    {activeImage ? t('common.fileActive') : t('common.file')}
                  </p>
                )}
              </div>
            </Dropzone>
            {/* Image */}
          </div>
          <div className="col">
            <div className="row">
              <div className="col-sm-6 col-md-4 col-lg-3">
                <Form.FieldInput
                  error={(isSubmitted && errors.key) || {}}
                  name={'key'}
                  label={t('employees.fields.key')}
                  handleChange={handleValueChange}
                  t={t}
                  value={values.key}
                />
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                <Form.FieldInput
                  error={(isSubmitted && errors.name) || {}}
                  name={'name'}
                  label={t('employees.fields.name')}
                  handleChange={handleValueChange}
                  t={t}
                  value={values.name}
                />
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                <Form.FieldInput
                  error={(isSubmitted && errors.lastname) || {}}
                  name={'lastname'}
                  label={t('employees.fields.lastname')}
                  handleChange={handleValueChange}
                  t={t}
                  value={values.lastname}
                />
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                <Form.FieldInput
                  error={(isSubmitted && errors.email) || {}}
                  name={'email'}
                  label={t('employees.fields.email')}
                  handleChange={handleValueChange}
                  t={t}
                  value={values.email}
                />
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                <Form.FieldInput
                  error={(isSubmitted && errors.position) || {}}
                  name={'position'}
                  label={t('employees.fields.position')}
                  handleChange={handleValueChange}
                  t={t}
                  value={values.position}
                />
              </div>

              <Form.CustomFields
                errors={errors}
                handleCustomFieldChange={handleCustomFieldChange}
                handleGroupChange={handleGroupChange}
                isSubmitted={isSubmitted}
                t={t}
                values={values}
                groups={groups}
              ></Form.CustomFields>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={createRoute(company.id, subcompany.id, `employees`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    key: {
      type: 'string',
      minLength: 1,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    lastname: {
      type: 'string',
      minLength: 1,
    },
    position: {
      type: 'string',
      minLength: 1,
    },
    email: {
      type: 'string',
      format: 'email',
      minLength: 1,
    },
  },
  required: ['key', 'name', 'lastname', 'position', 'email'],
})(translate()(EmployeeForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/form/EmployeeForm.js